import type { SelectOption } from 'contracts/Common';
import { COMPANY_SITE_TYPE_OPTIONS } from './CompanySiteType';

export const OPERATIONS_TYPES: SelectOption[] = [
  { value: 'inbound', label: 'Inbound' },
  { value: 'outbound', label: 'Outbound' }
]

const DOCUMENT_TYPES: SelectOption[] = [
  {
    value: 'cnpj',
    label: 'Pessoa Jurídica',
  },
  {
    value: 'cpf',
    label: 'Pessoa Física',
  },
  {
    value: 'other',
    label: 'Estrangeiro',
  },
];

const TYPE_DAY:SelectOption[] = [
  {
    value: 'UTEIS',
    label: 'Dias úteis'
  },
  {
    value: 'CORRIDO',
    label: 'Dias corridos'
  },
]

const STATES: SelectOption[] = [
  {
    value: 'AC',
    label: 'Acre',
  },
  {
    value: 'AL',
    label: 'Alagoas',
  },
  {
    value: 'AP',
    label: 'Amapá',
  },
  {
    value: 'AM',
    label: 'Amazonas',
  },
  {
    value: 'BA',
    label: 'Bahia',
  },
  {
    value: 'CE',
    label: 'Ceará',
  },
  {
    value: 'DF',
    label: 'Distrito Federal',
  },
  {
    value: 'ES',
    label: 'Espírito Santo',
  },
  {
    value: 'GO',
    label: 'Goiás',
  },
  {
    value: 'MA',
    label: 'Maranhão',
  },
  {
    value: 'MT',
    label: 'Mato Grosso',
  },
  {
    value: 'MS',
    label: 'Mato Grosso do Sul',
  },
  {
    value: 'MG',
    label: 'Minas Gerais',
  },
  {
    value: 'PA',
    label: 'Pará',
  },
  {
    value: 'PB',
    label: 'Paraíba',
  },
  {
    value: 'PR',
    label: 'Paraná',
  },
  {
    value: 'PE',
    label: 'Pernambuco',
  },
  {
    value: 'PI',
    label: 'Piauí',
  },
  {
    value: 'RJ',
    label: 'Rio de Janeiro',
  },
  {
    value: 'RN',
    label: 'Rio Grande do Norte',
  },
  {
    value: 'RS',
    label: 'Rio Grande do Sul',
  },
  {
    value: 'RO',
    label: 'Rondônia',
  },
  {
    value: 'RR',
    label: 'Roraima',
  },
  {
    value: 'SC',
    label: 'Santa Catarina',
  },
  {
    value: 'SP',
    label: 'São Paulo',
  },
  {
    value: 'SE',
    label: 'Sergipe',
  },
  {
    value: 'TO',
    label: 'Tocantins',
  },
];

const OPERATION_TYPES = [
  {label: 'ITO Comex', value: 1},
  {label: 'Toller', value: 2}
];

export const DELIVERED_OPTIONS_TYPES = [
  { label: 'Antecipada', value: 'early' },
  { label: 'No prazo', value: 'on_date' },
  { label: 'Atrasada', value: 'delayed' },
];

export const RETURN_OPTIONS_TYPES = [
  { label: 'No prazo', value: 'on_date' },
  { label: 'Atrasada', value: 'delayed' },
];



export const SELECT_OPTIONS = {
  DOCUMENT_TYPES,
  STATES,
  OPERATION_TYPES,
  TYPE_DAY,
  COMPANY_SITE_TYPES: COMPANY_SITE_TYPE_OPTIONS,
};